import React from 'react';
import { useAuthStore } from '../../context/AuthContext';
import useMsal from '../../auth/useMsal';
import {
    aboutPopupBackdropClass,
    aboutPopupContainerClass,
    userProfileWrpClass,
    popupHeaderClass,
    closeButtonClass,
    userInfoClass,
    rolesSectionClass,
    rolesListClass,
    roleItemClass,
    roleNameClass,
    systemInfoClass,
    popupActionsClass,
    CloseBtn,
    SignOutBtn,
} from './AboutPopup.styles';

interface AboutPopupProps {
    isOpen: boolean;
    onClose: () => void;
}

const AboutPopup: React.FC<AboutPopupProps> = ({ isOpen, onClose }) => {
    const { loggedInUser, roles } = useAuthStore();
    const { logoutAzAd } = useMsal();

    const logout = () => {
        logoutAzAd();
    };

    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={aboutPopupBackdropClass} onClick={handleBackdropClick}>
            <div className={aboutPopupContainerClass}>
                <div className={userProfileWrpClass}>
                    <div className={popupHeaderClass}>
                        <h2>User Profile</h2>
                        <button className={closeButtonClass} onClick={onClose}>
                            ×
                        </button>
                    </div>

                    {loggedInUser && (
                        <div className={userInfoClass}>
                            <h4>Logged in as: {loggedInUser.fullName || loggedInUser.userName || 'Unknown User'}</h4>

                            {roles && roles.length > 0 && (
                                <div className={rolesSectionClass}>
                                    <h4>
                                        <i className="glyphicon-shield">🛡️</i>
                                        User Roles:
                                    </h4>
                                    <div className={rolesListClass}>
                                        {roles.map((roleName, index) => (
                                            <div key={index} className={roleItemClass}>
                                                <span className={roleNameClass}>{roleName}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {(!roles || roles.length === 0) && (
                                <div className={rolesSectionClass}>
                                    <h4>
                                        <i className="glyphicon-shield">🛡️</i>
                                        User Roles:
                                    </h4>
                                    <p>No roles assigned</p>
                                </div>
                            )}

                            <div className={systemInfoClass}>
                                <h4>
                                    <i className="glyphicon-info">ℹ️</i>
                                    System Information
                                </h4>
                                <p>Application: Odfjell Commodity Book</p>
                                <p>Version: 2.0</p>
                                <p>Last Updated: {new Date().toLocaleDateString()}</p>
                            </div>
                        </div>
                    )}

                    <div className={popupActionsClass}>
                        <SignOutBtn onClick={logout}>Sign out</SignOutBtn>
                        <CloseBtn onClick={onClose}>Close</CloseBtn>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutPopup;
